import React from 'react';

import ProviderLogo from '~/components/Shared/ProviderLogo/ProviderLogo';
import { Button } from '~/eds/src/components/Button/Button';
import { Card } from '~/eds/src/components/Card/Card';
import { Divider } from '~/eds/src/components/Divider/Divider';
import { Icon } from '~/eds/src/components/Icon/Icon';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import Box from '~/ui/components/Box/Box';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import { useHover } from '~/ui/hooks/interaction';

const CARD_PADDING = 4;

const Footer = ({ children }) => (
  <Layout
    align="center"
    flex="none"
    direction="column"
    py={4}
    sx={{
      borderTop: 'border',
      height: '48px',
    }}
  >
    {children}
  </Layout>
);

function IntegrationCard({
  action,
  description,
  inactiveMessage,
  name,
  provider,
  status,
  enableStatusDetails = true,
}) {
  const [hoverRef, isHovered] = useHover();

  const statusDetails = inactiveMessage ? (
    <Text>{inactiveMessage}</Text>
  ) : status ? (
    status
  ) : (
    <Icon icon="plus-circle" />
  );

  const actionButton = (
    <Button
      text={action.text}
      id={action.id}
      variant="action"
      onClick={action.onClick}
      shouldTruncate
      isFullWidth
    />
  );

  const details = description && isHovered && (
    <FlexLayout
      bg="white"
      alignItems="stretch"
      flexDirection="column"
      justifyContent="space-between"
      p={CARD_PADDING}
      sx={{
        bottom: 0,
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
      }}
    >
      <Text>{description}</Text>
      <Footer>{actionButton}</Footer>
    </FlexLayout>
  );

  return (
    <Box
      disabled={Boolean(inactiveMessage)}
      ref={hoverRef}
      sx={{
        border: 'border',
        borderColor: isHovered ? 'gray-600' : undefined,
        borderRadius: 'm',
        overflow: 'hidden',
        position: 'relative',
        width: '214px',
      }}
    >
      <Card>
        <Layout align="center" direction="column" spacing={6}>
          <ProviderLogo provider={provider} />
          <Text variant="body-bold">{name}</Text>
          <Divider />
          <Layout align="center">
            {enableStatusDetails ? statusDetails : actionButton}
          </Layout>
          {enableStatusDetails && details}
        </Layout>
      </Card>
    </Box>
  );
}
export default IntegrationCard;
